export const blockNumbersParameters = {
  'Filter.From': 'Filter.From',
  'Filter.To': 'Filter.To',
  PageIndex: 'PageIndex',
  PageSize: 'PageSize',
  SortKeySelector: 'SortKeySelector',
  'Filter.TextSearch': 'Filter.TextSearch',
  SortOrder: 'SortOrder',
};
